export enum ServicePrincipalPermissionRole
{
    Client = "Client",
    Resource = "Resource",
}